import { useContext } from 'react';
import { Card } from '../components/ui/cards'
import { MapPin, Gauge, TrendingDown, Globe, Building, Shield } from "lucide-react";
import Context from '../../common/components/utils/context';

export const Features = () => {
  const context = useContext(Context)
  const features = [
    {
      icon: MapPin,
      titleKey: "Precise AR Placement",
      descriptionKey: "Position digital assets exactly where they belong in the real world with high accuracy",
    },
    {
      icon: Globe,
      titleKey: "Works Anywhere",
      descriptionKey: "No GPS needed—perfect for underground, indoor, and remote locations",
    },
    {
      icon: Building,
      titleKey: "Universal Compatibility",
      descriptionKey: "Works with any standard mobile device—no specialized hardware required",
    },
    {
      icon: Gauge,
      titleKey: "Real-Time Updates",
      descriptionKey: "Instant synchronization across your team, keeping everyone on the same page",
    },
    {
      icon: TrendingDown,
      titleKey: "Easy Integration",
      descriptionKey: "Seamless connection with your existing GIS, CAD, and asset management systems",
    }
  ];

  return (
    <section ref={context.homepageSections.features} id="features" className="relative py-20 bg-gradient-to-b from-home-background via-home-primary/5 to-home-accent/10">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,1)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,1)_1px,transparent_1px)] bg-[size:40px_40px] z-10"></div>
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 z-20">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-home-foreground mb-4">
            Why Choose FoundAt?
          </h2>
          <p className="text-xl text-home-muted-foreground max-w-2xl mx-auto">
            Advanced AR technology designed specifically for infrastructure and utility management
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card
              key={index}
              className="p-6 hover:shadow-md hover:shadow-home-primary/20 hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className="flex items-start gap-4">
                <div className="p-3 rounded-lg bg-home-primary/15 border-2 border-logo transition-colors">
                  <feature.icon className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-home-foreground mb-2">{feature.titleKey}</h3>
                  <p className="text-home-muted-foreground">{feature.descriptionKey}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
